<template>
  <!-- Figma UQ "TradeCall Fee Disclaimer": header band + red X, justified text, two radio boxes, solid teal Submit -->
  <div class="modal-content select-none">
    <div class="modal-body !p-[15px] font-roboto">
      <FxModalHeader title="TradeCall Fee Disclaimer" @close="closeModal" />
      <div class="px-[10px] laptop:px-[5px] flex flex-col gap-[15px] w-full">
        <div>
          <p class="m-0 text-[14px] laptop:text-[15px] font-normal text-justify leading-[20px] text-[#666666]">
            This claim request includes a TradeCall fee for
            {{ apptDetail.depp_schedule.tradecall_fee_text ?? $0 }}, which
            is the sole responsibility of the Technician working on this
            claim request, to collect from the consumer.
          </p>
          <p class="m-0 text-[14px] laptop:text-[15px] font-normal text-justify leading-[20px] text-[#666666]">
            Should you fail to collect the TradeCall from the Consumer, fyxify™ will not be
            responsible for reimbursing the same.
          </p>
        </div>
        <ul class="p-0 m-0 flex flex-col gap-[10px] list-none" role="radiogroup" aria-label="TradeCall fee">
          <li v-for="opt in options" :key="opt.value">
            <label
              class="m-0 flex items-center gap-[10px] px-[10px] py-[10px] rounded-[5px] cursor-pointer bg-[#F5F5F5] border-1"
              :class="check === opt.value ? 'border-[#BA90C6]' : 'border-[#F5F5F5]'">
              <!-- native radio (visually hidden, still focusable) + custom dot -->
              <input v-model="check" :value="opt.value" type="radio" name="tradeCallFee" class="sr-only peer">
              <span
                class="flex-shrink-0 w-[16px] h-[16px] border-1 rounded-full flex items-center justify-center bg-white peer-focus-visible:ring-2 peer-focus-visible:ring-[#BA90C6]"
                :class="check === opt.value ? 'border-[#BA90C6]' : 'border-[#999999]'">
                <span v-if="check === opt.value" class="w-[8px] h-[8px] bg-[#BA90C6] rounded-full" />
              </span>
              <span class="text-[13px] laptop:text-[14px] text-[#333333]">{{ opt.label }}</span>
            </label>
          </li>
        </ul>
        <div class="flex justify-center">
          <button type="button" class="fxBtnPrimary" @click="confirm">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { enableScroll } from "../../helpers/scrollHelper";
import FxModalHeader from "../nest_components/FxModalHeader.vue";

export default {
  components: { FxModalHeader },

  data() {
    return {
      check: "0",
      // values sent back as before: "0" collect the fee, "1" waive it
      options: [
        { value: "0", label: "I accept that I will collect TradeCall fees from consumer." },
        { value: "1", label: "Waive TradeCall fees for this job." },
      ],
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "apptDetail"]),
  },

  watch: {},

  mounted() { },

  methods: {
    ...mapActions(["setCommponent"]),

    editQuoteClicked() {
      this.setCommponent("QuoteItems");
    },

    closeModal() {
      document.documentElement.style.overflow = '';
      enableScroll()
      this.check = "0";
      this.$emit("event", "close");
    },

    confirm() {
      document.documentElement.style.overflow = '';
      enableScroll()
      this.$emit("event", "confirm", this.check);

      // this.$emit("event", "confirm");
      // if (this.check) {
      //   this.check = false;
      //   this.$emit("event", "confirm");
      // } else {
      //   toast.error("You must agree to above condition to continue.");
      // }
    },
  },
};
</script>
